import styled from '@emotion/styled'

export const DIV = styled.div((props)=>({
    ...props.className,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    '.modal-header': {
        background: 'lightgrey',
        width: '100%',
        height: 47,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#4b4b4b',
        position: 'relative !important',
        img: {
            marginRight: 20
        }
    },
    '.modal-footer': {
        padding: '20px 15px',
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        '&>*': {
            marginLeft: 10
        }
    }
}))